import { selectMissingRecipeCost } from "../../../selectors/selectRecipeInfo";
export var checkHasEnoughResourcesForCultivation = function (path) { return function (action, state$) {
    var state = state$.value;
    var missingResources = selectMissingRecipeCost(state, action.recipe.recipe.id, 1);
    if (missingResources.length > 0) {
        return path;
    }
    return undefined;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/nursery/checks/checkHasEnoughResourcesForCultivation.ts
// module id = 2028
// module chunks = 3